module.exports = __webpack_public_path__ + "img/category_cover_Drama.af762fc.webp";